/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TurfsRouteImport } from './routes/turfs'
import { Route as InstallRouteImport } from './routes/install'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TurfsIndexRouteImport } from './routes/turfs/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as TurfsTurfSlugRouteImport } from './routes/turfs/$turfSlug'
import { Route as LegalPlayerAgreementRouteImport } from './routes/legal/player-agreement'
import { Route as AuthStaffRedirectRouteImport } from './routes/auth/staff-redirect'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'

const TurfsRoute = TurfsRouteImport.update({
  id: '/turfs',
  path: '/turfs',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallRoute = InstallRouteImport.update({
  id: '/install',
  path: '/install',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TurfsIndexRoute = TurfsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TurfsRoute,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const TurfsTurfSlugRoute = TurfsTurfSlugRouteImport.update({
  id: '/$turfSlug',
  path: '/$turfSlug',
  getParentRoute: () => TurfsRoute,
} as any)
const LegalPlayerAgreementRoute = LegalPlayerAgreementRouteImport.update({
  id: '/legal/player-agreement',
  path: '/legal/player-agreement',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthStaffRedirectRoute = AuthStaffRedirectRouteImport.update({
  id: '/auth/staff-redirect',
  path: '/auth/staff-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/install': typeof InstallRoute
  '/turfs': typeof TurfsRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/staff-redirect': typeof AuthStaffRedirectRoute
  '/legal/player-agreement': typeof LegalPlayerAgreementRoute
  '/turfs/$turfSlug': typeof TurfsTurfSlugRoute
  '/app/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/turfs/': typeof TurfsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/install': typeof InstallRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/staff-redirect': typeof AuthStaffRedirectRoute
  '/legal/player-agreement': typeof LegalPlayerAgreementRoute
  '/turfs/$turfSlug': typeof TurfsTurfSlugRoute
  '/app': typeof AppIndexRoute
  '/auth': typeof AuthIndexRoute
  '/turfs': typeof TurfsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/install': typeof InstallRoute
  '/turfs': typeof TurfsRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/staff-redirect': typeof AuthStaffRedirectRoute
  '/legal/player-agreement': typeof LegalPlayerAgreementRoute
  '/turfs/$turfSlug': typeof TurfsTurfSlugRoute
  '/app/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/turfs/': typeof TurfsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/install'
    | '/turfs'
    | '/auth/callback'
    | '/auth/staff-redirect'
    | '/legal/player-agreement'
    | '/turfs/$turfSlug'
    | '/app/'
    | '/auth/'
    | '/turfs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/install'
    | '/auth/callback'
    | '/auth/staff-redirect'
    | '/legal/player-agreement'
    | '/turfs/$turfSlug'
    | '/app'
    | '/auth'
    | '/turfs'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/install'
    | '/turfs'
    | '/auth/callback'
    | '/auth/staff-redirect'
    | '/legal/player-agreement'
    | '/turfs/$turfSlug'
    | '/app/'
    | '/auth/'
    | '/turfs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  InstallRoute: typeof InstallRoute
  TurfsRoute: typeof TurfsRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthStaffRedirectRoute: typeof AuthStaffRedirectRoute
  LegalPlayerAgreementRoute: typeof LegalPlayerAgreementRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/turfs': {
      id: '/turfs'
      path: '/turfs'
      fullPath: '/turfs'
      preLoaderRoute: typeof TurfsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/install': {
      id: '/install'
      path: '/install'
      fullPath: '/install'
      preLoaderRoute: typeof InstallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/turfs/': {
      id: '/turfs/'
      path: '/'
      fullPath: '/turfs/'
      preLoaderRoute: typeof TurfsIndexRouteImport
      parentRoute: typeof TurfsRoute
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/turfs/$turfSlug': {
      id: '/turfs/$turfSlug'
      path: '/$turfSlug'
      fullPath: '/turfs/$turfSlug'
      preLoaderRoute: typeof TurfsTurfSlugRouteImport
      parentRoute: typeof TurfsRoute
    }
    '/legal/player-agreement': {
      id: '/legal/player-agreement'
      path: '/legal/player-agreement'
      fullPath: '/legal/player-agreement'
      preLoaderRoute: typeof LegalPlayerAgreementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/staff-redirect': {
      id: '/auth/staff-redirect'
      path: '/auth/staff-redirect'
      fullPath: '/auth/staff-redirect'
      preLoaderRoute: typeof AuthStaffRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface TurfsRouteChildren {
  TurfsTurfSlugRoute: typeof TurfsTurfSlugRoute
  TurfsIndexRoute: typeof TurfsIndexRoute
}

const TurfsRouteChildren: TurfsRouteChildren = {
  TurfsTurfSlugRoute: TurfsTurfSlugRoute,
  TurfsIndexRoute: TurfsIndexRoute,
}

const TurfsRouteWithChildren = TurfsRoute._addFileChildren(TurfsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  InstallRoute: InstallRoute,
  TurfsRoute: TurfsRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthStaffRedirectRoute: AuthStaffRedirectRoute,
  LegalPlayerAgreementRoute: LegalPlayerAgreementRoute,
  AuthIndexRoute: AuthIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
